import React from "react";
import TuneIcon from "@mui/icons-material/Tune";

// Catálogo de plantillas/sección — mismo catálogo fijo que FiltroMensajeriaEnviada (listado
// mensajería original)
const PLANTILLAS_CATALOGO = [
    { id: "CT", nombre: "Cotizaciones" },
    { id: "GT", nombre: "Garantía Temprana" },
    { id: "GD", nombre: "Garantías Tardías" },
    { id: "CH", nombre: "Checklist" },
    { id: "MT", nombre: "Mantenimiento" },
    { id: "CV", nombre: "Cartera Vencida" },
    { id: "CP", nombre: "Cartera por Vencer" },
    { id: "PR", nombre: "Promoción de refacciones" },
];

// Panel lateral de filtros: rango de fechas, sucursales, líneas (Posventa/Cobranza) y plantilla
// sucursales: [{ id, nombre }] — ids reales del catálogo de sucursales (igual que MensajeriaScreen)
// onAplicar (opcional): cuando se pasa, muestra un botón "Aplicar filtros" que la dispara —
// usado por pantallas que filtran contra el API (Indicadores) en vez de en el cliente
export const MensajeriaFiltrosPanel = ({ filtros, setFiltros, sucursales, onAplicar }) => {
    const toggleSucursal = (id) => {
        setFiltros((prev) => ({
            ...prev,
            sucursales: prev.sucursales.includes(id)
                ? prev.sucursales.filter((s) => s !== id)
                : [...prev.sucursales, id],
        }));
    };

    const toggleLinea = (linea) => {
        setFiltros((prev) => ({
            ...prev,
            lineas: prev.lineas.includes(linea)
                ? prev.lineas.filter((l) => l !== linea)
                : [...prev.lineas, linea],
        }));
    };

    return (
        <div className="mjr-filtros scroll">
            <div className="mjr-filtros-header">
                <TuneIcon />
                <span>Filtros</span>
            </div>

            <div className="mjr-filtros-seccion">
                <h4>Periodo</h4>
                <label className="mjr-filtros-label">Fecha inicio</label>
                <input
                    type="date"
                    className="mjr-filtros-input"
                    value={filtros.fechaInicio}
                    onChange={(e) => setFiltros((prev) => ({ ...prev, fechaInicio: e.target.value }))}
                />
                <label className="mjr-filtros-label">Fecha fin</label>
                <input
                    type="date"
                    className="mjr-filtros-input"
                    value={filtros.fechaFin}
                    onChange={(e) => setFiltros((prev) => ({ ...prev, fechaFin: e.target.value }))}
                />
            </div>

            <div className="mjr-filtros-seccion">
                <h4>Sucursales</h4>
                {sucursales.map((s) => (
                    <label key={s.id} className="mjr-filtros-check">
                        <input
                            type="checkbox"
                            checked={filtros.sucursales.includes(s.id)}
                            onChange={() => toggleSucursal(s.id)}
                        />
                        {s.nombre}
                    </label>
                ))}
            </div>

            <div className="mjr-filtros-seccion">
                <h4>Plantilla</h4>
                <select
                    className="mjr-filtros-input"
                    value={filtros.plantilla || ""}
                    onChange={(e) => setFiltros((prev) => ({ ...prev, plantilla: e.target.value }))}
                >
                    <option value="">Todas</option>
                    {PLANTILLAS_CATALOGO.map((p) => (
                        <option key={p.id} value={p.id}>{p.nombre}</option>
                    ))}
                </select>
            </div>

            <div className="mjr-filtros-seccion">
                <h4>Líneas</h4>
                <label className="mjr-filtros-check">
                    <input
                        type="checkbox"
                        checked={filtros.lineas.includes("Posventa")}
                        onChange={() => toggleLinea("Posventa")}
                    />
                    Posventa
                </label>
                <label className="mjr-filtros-check">
                    <input
                        type="checkbox"
                        checked={filtros.lineas.includes("Cobranza")}
                        onChange={() => toggleLinea("Cobranza")}
                    />
                    Cobranza
                </label>
            </div>

            {onAplicar && (
                <button type="button" className="mjr-filtros-btn-aplicar" onClick={onAplicar}>
                    Aplicar filtros
                </button>
            )}
        </div>
    );
};
